module.exports = __webpack_public_path__ + "img/Form2.9a30edf1.png";